export function marketplaceShopPath(shopSlug: string): string {
  return `/market/shop/${encodeURIComponent(shopSlug)}`;
}
